export const ADD_SUCC = "success";
export const ADD_SUCC_TITLE = "Booking confirmed";
export const ADD_SUCC_DESC = "The booking has been registered correctly";

export const ADD_ERR = "error";
export const ADD_ERR_TITLE = "There was a problem";
export const ADD_ERR_DESC = "The booking has not been registered";

export const EDIT_SUCC = "info";
export const EDIT_SUCC_TITLE = "Booking updated";
export const EDIT_SUCC_DESC = "The booking has been updated correctly";

export const EDIT_ERR = "error";
export const EDIT_ERR_TITLE = "There was a problem";
export const EDIT_ERR_DESC = "The booking has not been registered";

export const DEL_SUCC = "success";
export const DEL_SUCC_TITLE = "Booking deleted";
export const DEL_SUCC_DESC = "The reservation has been deleted";
